var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"purchase-btn",class:{ 'purchase-arrow': _vm.isArrow },on:{"click":function($event){$event.stopPropagation();return _vm.handleSquareBtnClick.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.localizedText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }